import React, { useState } from "react";
import { Creatable } from "react-select";
import { getSelectedAccountId } from "containers/Accounts/reducer";
import { getSelectedFolder } from "containers/Folders/reducer";
import { addCorpusDocument, createArtifact, getArtifact, getArtifactList, uploadArtifactAsset, createFineTunedModel } from "containers/LanguageModelArtifact/reducer";
import { useSelector, useDispatch } from "types/store";
import { customMapper, selectOnChangeWrapper } from "utils/select";
import { Button } from "aible";
const ARTIFACT_TYPE_LABELS = {
    CORPUS: "Language Model Document Set",
    FINE_TUNED_MODEL: "Fine Tuned Model",
    FINE_TUNING_DATA: "Language Model Training Data"
};
const ARTIFACT_TYPE_UPLOAD_LABELS = {
    CORPUS: "Document",
    FINE_TUNED_MODEL: "Model Data",
    FINE_TUNING_DATA: "Training Data"
};
const ArtifactSelector = ({ type, onChange, artifactId, allowUpload, hideLabel, labelOverride, placeholder }) => {
    const dispatch = useDispatch();
    const [selectedModel, updateSelectedModel] = useState();
    const accountId = useSelector((state) => getSelectedAccountId(state));
    const folderId = useSelector((state) => getSelectedFolder(state));
    const selectedArtifact = useSelector((state) => getArtifact(state, type, artifactId ?? -1));
    const artifacts = useSelector((state) => getArtifactList(state, type));
    const mapper = customMapper((x) => `${x.name}`);
    const createOption = { name: "Create New" };
    const isUploading = false;
    const handleOnChange = (t) => {
        if (t !== undefined) {
            onChange(t);
        }
    };
    const options = mapper.mapAll([createOption, ...artifacts]);
    const value = mapper.map(selectedArtifact);
    const onChangeHandler = selectOnChangeWrapper(handleOnChange);
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: "2px" } }, labelOverride ? labelOverride : ARTIFACT_TYPE_LABELS[type]),
        React.createElement(Creatable, { options: options, value: value, onChange: onChangeHandler, onCreateOption: (name) => {
                if (type !== "FINE_TUNED_MODEL") {
                    dispatch(createArtifact(accountId, folderId, type, name)).then((artifact) => onChange(artifact));
                }
            }, placeholder: placeholder ? placeholder : type === "FINE_TUNING_DATA" ? `Select a dataset` : `Select a value...`, label: ARTIFACT_TYPE_LABELS[type], menuPlacement: "bottom" }),
        (allowUpload || true) && selectedArtifact !== undefined && (React.createElement(React.Fragment, null,
            selectedArtifact.type === "CORPUS" && (React.createElement("div", { style: { marginTop: "5px" } },
                React.createElement(Button, { onClick: () => document.getElementById("fUploadLLMDocs")?.click(), type: "secondary", isSmall: true, style: {
                        whiteSpace: "nowrap",
                        marginRight: "5px"
                    }, isLoading: isUploading }, `Upload ${ARTIFACT_TYPE_UPLOAD_LABELS[type]}`),
                React.createElement("div", { style: { display: "none" } },
                    React.createElement("input", { type: "file", id: "fUploadLLMDocs", onChange: (e) => {
                            const file = e.currentTarget.files ? e.currentTarget.files[0] : undefined;
                            if (file !== undefined) {
                                if (selectedArtifact.type === "CORPUS") {
                                    dispatch(addCorpusDocument(selectedArtifact, file));
                                }
                                else {
                                    dispatch(uploadArtifactAsset(selectedArtifact, file));
                                }
                            }
                        } })))),
            selectedArtifact.type === "FINE_TUNING_DATA" && false && (React.createElement("div", { style: { marginTop: "5px" } },
                React.createElement(ArtifactSelector, { type: "FINE_TUNED_MODEL", artifactId: selectedModel?.id, onChange: (t) => updateSelectedModel(t) }),
                React.createElement(Button, { onClick: () => {
                        if (selectedModel !== undefined) {
                            return;
                        }
                        else {
                            dispatch(createFineTunedModel(accountId, folderId, "test tune model"));
                        }
                    }, type: "secondary", isSmall: true, style: {
                        whiteSpace: "nowrap",
                        marginRight: "5px"
                    } }, `Train Fine Tuning Model`)))))));
};
export default ArtifactSelector;
